import React from 'react';
import { Map as LeafletMap, Marker, TileLayer } from 'react-leaflet';
import L from 'leaflet';

const OSM_TILE_URL = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
const DEFAULT_ZOOM = 16;

// Defined at module level to avoid re-instantiating the Leaflet object on every render.
// Inline styles on the inner <span> make the pin self-contained — no dependency on
// CSS classes from PublicMapView/style.scss, which may not be in this bundle chunk.
const submissionPinIcon = L.divIcon({
  html:
    '<span aria-hidden="true" style="display:block;width:22px;height:22px;border-radius:50%;' +
    'background-color:#FFBCBC;border:2px solid #EF1414;box-sizing:border-box"></span>' +
    '<span class="sr-only">Submission location</span>',
  className: 'submission-static-map__pin',
  iconSize: L.point(14, 14),
  iconAnchor: L.point(7, 7),
});

interface ISubmissionStaticMapProps {
  lat: number;
  long: number;
}

export default function SubmissionStaticMap({ lat, long }: ISubmissionStaticMapProps) {
  return (
    <div
      className="submission-detail__location-map"
      role="region"
      aria-label="Map showing submission location"
    >
      <LeafletMap
        center={[lat, long]}
        zoom={DEFAULT_ZOOM}
        zoomControl={false}
        scrollWheelZoom={false}
        dragging={false}
        touchZoom={false}
        doubleClickZoom={false}
        boxZoom={false}
        keyboard={false}
        attributionControl={false}
        style={{ height: '100%', width: '100%' }}
      >
        <TileLayer url={OSM_TILE_URL} />
        <Marker position={[lat, long]} icon={submissionPinIcon} />
      </LeafletMap>
    </div>
  );
}
